// Public browser client token (post_client_item). The Rails page already
// ships this same value. It is not the server-side Rollbar token.
export const ROLLBAR_CLIENT_ACCESS_TOKEN = "e529609750934944866fa9fcbed2f34a";

// Entry script hosts. Chunks use the webpack public path, which is a
// per-deploy Vercel host, so callers also pass that host in.
export const ROLLBAR_BUNDLE_HOSTS = ["js.skipiocdn.com", "vercel.skipio.com"];

declare let __webpack_public_path__: string | undefined;

const ENVIRONMENTS: Record<string, string> = {
  "app.skipio.com": "production",
  "qa.skipio.com": "qa",
  "stage.skipio.com": "staging",
};

declare const __ROLLBAR_CODE_VERSION__: string | undefined;

export function rollbarEnvironment(hostname: string): string | null {
  return ENVIRONMENTS[hostname] ?? null;
}

export function rollbarCodeVersion(): string {
  return typeof __ROLLBAR_CODE_VERSION__ === "string"
    ? __ROLLBAR_CODE_VERSION__
    : "";
}

export function hostnameFrom(value: string, base: string): string | null {
  try {
    const url = new URL(value, base);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url.hostname || null;
  } catch (error) {
    return null;
  }
}

export function rollbarBundleHosts({
  publicPath = "",
  scriptSrcs = [],
  base = "https://app.skipio.com/",
}: {
  publicPath?: string;
  scriptSrcs?: string[];
  base?: string;
} = {}): string[] {
  const hosts = new Set<string>(ROLLBAR_BUNDLE_HOSTS);
  const publicHost = publicPath ? hostnameFrom(publicPath, base) : null;
  if (publicHost) hosts.add(publicHost);
  for (const src of scriptSrcs) {
    if (!src.includes("/dist/")) continue;
    const host = hostnameFrom(src, base);
    if (host) hosts.add(host);
  }
  return Array.from(hosts);
}

function currentBundleHosts(): string[] {
  const publicPath =
    typeof __webpack_public_path__ === "string" ? __webpack_public_path__ : "";
  const scriptSrcs =
    typeof document === "undefined"
      ? []
      : Array.from(document.scripts).map((script) => script.src);
  const base =
    typeof window === "undefined"
      ? "https://app.skipio.com/"
      : window.location.href;
  return rollbarBundleHosts({ publicPath, scriptSrcs, base });
}

export function buildRollbarConfig(
  hostname: string,
  codeVersion = rollbarCodeVersion()
) {
  const environment = rollbarEnvironment(hostname);
  const reporting = environment !== null;

  return {
    accessToken: ROLLBAR_CLIENT_ACCESS_TOKEN,
    enabled: reporting,
    captureUncaught: reporting,
    captureUnhandledRejections: reporting,
    autoInstrument: reporting,
    hostSafeList: currentBundleHosts(),
    payload: {
      environment: environment ?? "development",
      ...(codeVersion ? { code_version: codeVersion } : {}),
      client: {
        javascript: {
          source_map_enabled: true,
          ...(codeVersion ? { code_version: codeVersion } : {}),
        },
      },
    },
  };
}
